import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  claimTaskMutation,
  claimTaskMutationVariables,
} from './__generated__/useClaimTask.graphql.ts';

const CLAIM_TASK_MUTATION = gql`
  mutation claimTaskMutation(
    $taskId: ID!
    $sport: Sport!
    $signedAlternativeRewardConfigs: String
  ) {
    claimTask(
      input: {
        taskId: $taskId
        signedAlternativeRewardConfigs: $signedAlternativeRewardConfigs
      }
    ) {
      task {
        id
        aasmState
        ... on ThresholdsStreakTask {
          id
          currentThresholdStatus {
            state
          }
        }
      }
      currentUser {
        slug
        xpBalances: inGameCurrencyBalances(
          sport: $sport
          inGameCurrencies: [
            COMMON_XP
            LIMITED_XP
            RARE_XP
            SUPER_RARE_XP
            UNIQUE_XP
          ]
        ) {
          amount
          currency
          capAlmostReached
        }
        gemsBalances: inGameCurrencyBalances(
          sport: $sport
          inGameCurrencies: [COMMON_GEM]
        ) {
          amount
        }
        cardShardsChests(
          sport: $sport
          rarities: [common, limited, rare, super_rare, unique]
        ) {
          id
          rarity
          cardShardsCount
          newThresholdUnlocked
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<claimTaskMutation, claimTaskMutationVariables>;

export const useClaimTask = () => {
  return useMutation(CLAIM_TASK_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
};
